// Display and drag/drop share the same stable order within each category.
export function orderedCategoryTasks(tasks, category) {
  return tasks.filter((task) => task.category === category).sort((a, b) =>
    Number(Boolean(a.completed)) - Number(Boolean(b.completed)) ||
    (a.order || 0) - (b.order || 0)
  );
}

export function moveWithinCompletionGroup(tasks, oldIndex, newIndex) {
  const source = tasks[oldIndex];
  const target = tasks[newIndex];
  if (!source || !target || oldIndex === newIndex ||
      Boolean(source.completed) !== Boolean(target.completed)) return null;
  const result = [...tasks];
  result.splice(newIndex, 0, result.splice(oldIndex, 1)[0]);
  return result;
}
